module.exports = __webpack_public_path__ + "static/media/chiller_control_wave_icon.248d028a.svg";